import { Box } from '@mui/material';

import { usePlanEditor } from './editor';
import { PlanVsBudgetPanel } from './PlanVsBudgetPanel';
import { TaskInsightPanel } from './TaskInsightPanel';

/**
 * The contextual right-hand content: plan-vs-budget by default, task insight
 * alone while a row is active.
 *
 * This used to be the rail itself — a hardcoded 340px `<aside>` with its own
 * border and scroll container, duplicated byte-for-byte in
 * financials/ProjectBudgetAside. The rail is now `Panels.Drawer`, which brings
 * drag-to-resize, a persisted width and a collapse control with it, so this
 * component is only the content.
 *
 * It has no header of its own (2026-09-24, the pilot's ask): the project's
 * identity is the page header's job and the rail is for numbers — the same
 * call the Financials aside took the same day. The rail's one title,
 * "Project summary", lives on the drawer's collapse row
 * (`PlanDrawerHeading`); with a task selected that row carries only the way
 * back to the project, and the rail is the task insight and nothing else
 * (2026-09-28 — the plan-vs-budget section, and before it a condensed
 * "Project total" band, used to sit above it). The customer is stated nowhere
 * on Planning (the zero-contract Financials aside keeps `AsideHeader`).
 */
export const SidePanel = () => {
  const { state } = usePlanEditor();
  const activeId = state.activeId;

  return (
    <Box data-automation-id="side-panel">
      {activeId ? <TaskInsightPanel nodeId={activeId} /> : <PlanVsBudgetPanel />}
    </Box>
  );
};
